const DEFAULT_HEIGHT = 420;
const MIN_HEIGHT = 200;
const MAX_HEIGHT = 2000;
const IFRAME_SANDBOX = [
  "allow-scripts",
  "allow-forms",
  "allow-popups",
  "allow-popups-to-escape-sandbox",
  "allow-presentation",
].join(" ");

function normalizeHeight(height) {
  const parsed = Number.parseInt(height, 10);
  if (Number.isNaN(parsed)) return DEFAULT_HEIGHT;
  return Math.min(MAX_HEIGHT, Math.max(MIN_HEIGHT, parsed));
}

function buildSrcDoc(code) {
  return `<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
      html, body {
        margin: 0;
        padding: 0;
        background: transparent;
      }

      body {
        overflow-x: hidden;
      }

      img, video, iframe {
        max-width: 100%;
      }

      iframe {
        border: 0;
      }
    </style>
  </head>
  <body>${code || ""}</body>
</html>`;
}

function hasRenderableCode(code) {
  return String(code || "")
    .replace(/<!--[\s\S]*?-->/g, "")
    .trim().length > 0;
}

const TutorialCustomHtmlBlock = ({ block }) => {
  if (!hasRenderableCode(block?.code)) return null;

  return (
    <iframe
      title={`Tutorial custom content ${block.id || ""}`.trim()}
      srcDoc={buildSrcDoc(block.code)}
      sandbox={IFRAME_SANDBOX}
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
      allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
      allowFullScreen
      style={{
        display: "block",
        width: "100%",
        minHeight: `${MIN_HEIGHT}px`,
        height: `${normalizeHeight(block.height)}px`,
        border: 0,
        background: "transparent",
      }}
    />
  );
};

export default TutorialCustomHtmlBlock;
